import { render } from "./class_log.vue?vue&type=template&id=9b79d99c"
import script from "./class_log.vue?vue&type=script&lang=js"
export * from "./class_log.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__